<template>
  <div>
    <el-form

      ref="form"
      :model="form"
      :rules="rules"
      label-width="160px"
      :class="!isMarginIdx ? 'ccui-form' : 'ccui-form form-margin'"
    >
      <div class="title">
        <div class="titleText">
          {{ titleData.isAdd ? "公司资质" : titleData.name }}
        </div>
        <div v-if="titleData.isAdd" class="deleteIcon" @click="deleteClick">
          <i class="icon-ccui-delete"></i>
          删除资质
        </div>
      </div>
      <el-form-item v-if="titleData.isAdd" label="资质名称：" prop="fileName">
        <el-input
          v-model.trim="form.fileName"
          class="input-long"
          maxlength="100"
          placeholder="请输入资质名称"
        />
      </el-form-item>
      <el-form-item v-if="titleData.name === '商标注册证/商品注册申请书' || titleData.name === '商标注册证/商品注册申请书/经销商授权书'" label="发证机关及网址："  :prop="titleData.name === '邀请函'?'website':''">
        <el-input
          v-model.trim="form.website"
          class="input-long"
          @input="websiteInput"
          maxlength="100"
          placeholder="请输入发证机关及网址"
        />
      </el-form-item>
      <el-form-item v-if="titleData.isShowDateInput" label="有效期：" :prop="titleData.name === '邀请函'?'isStartEnd':''">
        <!--              prop="isStartEnd"
-->
        <!--        <span v-if="!titleData.isAdd" style="position: absolute;left: -62px;color: #F56C6C;">*</span>-->
        <el-date-picker
          v-model="form.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          @change="selectDateChange"
          clearable
          :picker-options="startPickerOptions"
          placeholder="开始时间"
        >
        </el-date-picker>
        <div style="display: inline-block; margin: 0 10px">-</div>
        <el-date-picker
          v-model="form.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          :disabled="!!form.checked"
          @change="selectDateChange"
          clearable
          :picker-options="endPickerOptions"
          placeholder="结束时间"
        >
        </el-date-picker>
        <span style="width: 28px; display: inline-block"></span>
        <el-checkbox
          @change="checkboxChange"
          :true-label="1"
          :false-label="0"
          v-model="form.checked"
          >长期</el-checkbox
        >
      </el-form-item>
      <el-form-item label="资质文件：" prop="upload">
        <el-file-upload
          style="height: 98px"
          ref="upload"
          readonly
          :on-change="changeFile"
          :on-success="handleSuccess"
          :on-delete="onFileDelete"
          :on-progress="onProgress"
          :file-list="fileList"
          :before-upload="beforeAvatarUpload"
          :on-error="onFileError"
          :auto-upload="true"
          :limit="1"
          :action="importFileUrl"
          file-ref="fileRef2"
          :handlePictureCardPreview="handlePictureCardPreview"
        >
        </el-file-upload>
        <!--        <span v-if="titleData.name === '法定代表人授权委托书'" class="template">-->
        <!--          请先下载 <a target="_blank" :href="downFileUrl" download="授权委托书模板.doc">授权委托书模板</a>-->
        <!--          ，按照要求填写后将文件扫描上传-->
        <!--        </span>-->
        <span
          v-if="titleData.name === '法定代表人店铺授权委托书'"
          class="template"
        >
          请先下载
          <a target="_blank" :href="downFileUrl1" download="授权委托书模板.doc"
            >授权委托书模板</a
          >
          ，按照要求填写后将文件扫描上传
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import imgBase64 from "./img-base64";
const charCheck = (rule, value, callback) => {
  let match = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
  if (value.match(match)) {
    callback(new Error("格式错误"));
  }
};
export default {
  props: {
    titleData: Object,
    isMarginIdx: Number,
    saleLimitFlag:String,
    isCheck: String,
    thisPage: String,
  },
  name: "upload-template",
  data() {
    return {
      downFileUrl: this.$addUrlPerFix(process.env.VUE_APP_FILE_URL),
      downFileUrl1: this.$addUrlPerFix(process.env.VUE_APP_FILE_URL_FILE),
      form: {
        isStartEnd: "",
        upload: "",
        startTime: "",
        endTime: "",
        time:'',
        fileName: "",
        website: "",
        checked: 0,
      },
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址
      fileList: [],
      startPickerOptions: {
        disabledDate: (time) => {
          let bfalse = false;
          if (this.form.endTime) {
            bfalse = time.getTime() > new Date(this.form.endTime).getTime();
          } else {
            bfalse = time.getTime() > new Date().getTime();
          }
          return bfalse;
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          let bfalse = false;
          if (this.form.startTime) {
            bfalse =
              time.getTime() < new Date(this.form.startTime).getTime() - 8.64e7;
          } else {
            bfalse = time.getTime() < new Date().getTime() - 8.64e7;
          }
          return bfalse;
        },
      },
      fileType: [
        { type: "xls,xlsx", base64: imgBase64.xls },
        { type: "doc,docx", base64: imgBase64.doc },
        { type: "zip,rar", base64: imgBase64.zip },
        { type: "txt", base64: imgBase64.txt },
        { type: "pdf", base64: imgBase64.pdf },
      ],
    };
  },
  computed: {

      rules(){
        const rules = {
          fileName: [
            { required: true, message: "请输入资质名称", trigger: "blur" },
            {
              validator: charCheck,
              message: "资质名称不可输入特殊字符",
              trigger: "blur",
            },
          ],
          upload: [
            { required: true, message: "请上传资质文件", trigger: "change" },
          ],
          website: [
            { required: true, message: "请填写发证机关及网址", trigger: "blur" },
          ],
          isStartEnd: [
            {
              required: true,
              message: "请选择有效期开始时间-结束时间",
              trigger: "blur",
            },
          ],
          // isStartEnd: [{ required: true, message: '请选择有效期开始时间-结束时间', trigger: 'blur' }]
        }
        if (this.titleData.name === "商标注册证/商品注册申请书" || this.titleData.name === "商标注册证/商品注册申请书/经销商授权书") {
          delete rules.upload;
        }
        return rules
      },
  },
  watch: {
    form: {
      handler(val) {
        //选择长期身份证的时候 清空一下时间有效期
        if (val.checked === 1) {
          val.endTime = "";
        }
        console.log(val, "撒旦法");
        if (!val.date) {
          this.startTime = "";
        }
      },
      deep: true,
    },
  },
  mounted() {
    console.log(this.titleData, "资质文件数据");
    if (this.titleData.fileList && this.titleData.fileList.length) {
      // if (!this.titleData.name.includes("身份证")) {
        this.form.upload = "1";
        let res = this.titleData.fileList[0].response.data[0];
        this.$set(this.fileList, 0, this.titleData.fileList[0]);
        // 判断是否是新增资质文件
        if (
          this.titleData.isDefault !== undefined &&
          this.titleData.isDefault === 0
        ) {
          this.form.fileName = this.titleData.name;
        }
        this.form.startTime = res.validityStart ? res.validityStart : "";
        this.form.endTime = res.validityEnd ? res.validityEnd : "";
        this.form.website = res.website ? res.website : "";
        this.form.checked = res.isLongValidity ? res.isLongValidity : 0;
        let urlFileTypeArr = this.titleData.fileList[0].url
          .split("?")[0]
          .split(".");
        let urlFileType = urlFileTypeArr[urlFileTypeArr.length - 1];
        this.fileType.forEach((item) => {
          if (item.type.includes(urlFileType)) {
            this.titleData.fileList[0].url = item.base64;
          }
        });
      // }
      this.checkDate(true);
      this.$forceUpdate();
    }
    for (let i in this.form) {
      if (this.titleData[i]) {
        this.form[i] = this.titleData[i];
      }
    }
    if (this.titleData.isDateInput) {
      console.log(this.rules.isStartEnd);
      if (this.rules.isStartEnd) this.rules.isStartEnd[0].required = true;
    } else {
      console.log(this.rules.isStartEnd);
      if (this.rules.isStartEnd) this.rules.isStartEnd[0].required = false;
    }
    // if (!this.titleData.isShowDateInput) {
    //   this.rules.isStartEnd[0].required = false
    // }
    if (!this.titleData.isAdd) {
      this.rules.zizhiName = [];
      delete this.form.zizhiName;
      delete this.rules.zizhiName;
    }
    this.$eventBus.$on("isCheck", this.eventBusFn);
    console.log(this.isCheck, "uploadIsCheck ");
    if (this.isCheck) {
      this.$eventBus.$on("isCheckFile", this.isCheckFile);
      this.clearRules(this.isCheck);
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("isCheck", this.eventBusFn);
    this.$eventBus.$off("isCheckFile", this.isCheckFile);
  },
  methods: {
    websiteInput(val) {
      if (!val) return false;
      this.form.website = val.replace(/\s*/g, "");
    },
    clearRules(val) {
      let clearRule = ["fileName", "upload", "isStartEnd",'website'];
      if (val === "no") {
        clearRule.forEach((item) => {
          this.rules[item][0].required = false;
        });
        this.$refs["form"].validate();
      } else if (val === "check") {
        clearRule.forEach((item) => {
          this.rules[item][0].required = true;
        });
      }
    },
    isCheckFile(val) {
      console.log(val, "大是大非");
      this.clearRules(val);
    },
    checkDate(isCheck) {
      this.form.isStartEnd = "1";
      if (!this.form.endTime && !this.form.checked) {
        this.form.isStartEnd = "";
        if (this.rules.isStartEnd)
          this.rules.isStartEnd[0].message = "请选择有效期结束时间";
      }
      if (!this.form.startTime) {
        this.form.isStartEnd = "";
        if (this.rules.isStartEnd)
          this.rules.isStartEnd[0].message = "请选择有效期开始时间";
      }
      if (!this.form.startTime && !this.form.endTime && !this.form.checked) {
        this.form.isStartEnd = "";
        if (this.rules.isStartEnd)
          this.rules.isStartEnd[0].message = "请选择有效期开始时间-结束时间";
      }
      if (isCheck) return false;
      this.$refs["form"].validateField("isStartEnd");
    },
    selectDateChange() {
      this.checkDate();
    },
    eventBusFn(res) {
      if (res && res === this.thisPage) {
        this.$refs["form"].validate();
      }
    },
    deleteClick() {
      // destroy the vue listeners, etc
      // remove the element from the DOM
      this.$emit("deleteClick", this.isMarginIdx);
      // this.$el.parentNode.removeChild(this.$el)
      // this.$destroy()
    },
    beforeAvatarUpload(file) {
      let isUpload = true;
      let fileType = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "pdf",
        "xls",
        "xlsx",
        "doc",
        "docx",
      ];
      let fileTypeLen = file.name.split(".");
      let isFile = fileType.includes(
        fileTypeLen[fileTypeLen.length - 1].toLowerCase()
      );
      let isFileIdx = fileType.indexOf(
        fileTypeLen[fileTypeLen.length - 1].toLowerCase()
      );
      const isLt5M = file.size / 1024 / 1024 < 5;
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (isFile) {
        if (!isLt5M && isFileIdx <= 3) {
          this.$message({
            type: "error",
            message: "上传图片大小不能超过 5MB!",
            offset: document.body.clientHeight / 2 - 21,
          });
          isUpload = false;
        } else if (!isLt15M) {
          this.$message({
            type: "error",
            message: "上传文件大小不能超过 15MB!",
            offset: document.body.clientHeight / 2 - 21,
          });
          isUpload = false;
        }
      } else {
        this.$message({
          type: "error",
          message: `上传文件支持格式：.jpg .png .jpeg .gif每个不超过5M，.xls .xlsx .doc .docx .pdf每个不超过15M`,
          offset: document.body.clientHeight / 2 - 21,
        });
      }
      return isUpload && isFile;
    },
    onFileError(err, file, fileList) {
      this.fileList = [];
      this.$message({
        type: "error",
        message: "文件上传失败！",
        offset: document.body.clientHeight / 2 - 21,
      });
    },
    onProgress(progressEvent) {
      if (progressEvent.percent > 98) {
        progressEvent.percent = 99;
      }
    },
    // 附件信息上传tu
    changeFile(file, fileList) {
      console.log("fileList:34234", fileList);
      this.fileList = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["zip", "rar"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/jpg;base64,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";
        } else if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },
    // 删除附件信息
    onFileDelete() {
      console.log("delete upload");
      this.fileList = [];
      this.form.upload = "";
      if (this.isCheck) {
        this.rules.isStartEnd[0].required = false;
        this.$refs["form"].validateField("isStartEnd");
      }
      this.$refs["form"].validateField("upload");
    },
    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      fileList[0].percentage = 100;
      if (response.code === "0") {
        this.form.upload = "1";
        this.$refs["form"].validateField("upload");
        if (!this.titleData.isAdd) {
          console.log(this.rules.isStartEnd);
          if (this.rules.isStartEnd) this.rules.isStartEnd[0].required = true;
        }
      } else {
        this.fileList = [];
        this.$message({
          type: "error",
          message: "文件上传失败！",
          offset: document.body.clientHeight / 2 - 21,
        });
      }
    },
    // 点击已上传附件信息的时触发
    handlePictureCardPreview(file, fileList) {
      console.log("aaa", file);
      console.log("bbb", fileList);
    },
    checkboxChange() {
      this.checkDate();
      // if (val) {
      //   this.form.endTime = ''
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  width: 620px;
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  .titleText {
    width: 250px;
    text-align: left;
    font-family: PingFangSC;
    font-weight: 600;
    color: #4a4a4a;
    margin-left: 25px;
  }
  .deleteIcon {
    color: #ff142f;
    cursor: pointer;
    user-select: none;
  }
}
/deep/ .form-margin {
  margin-top: 0;
}
/deep/ .el-date-editor.el-input {
  width: 192px;
}
.template {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 6px;
  a {
    color: #0089ef;
  }
}
</style>
